import { checkValuesOfKey } from "../utils/customFields";
export const getStatusName = (status) => {
  let name;
  switch (status) {
    case 0:
      name = "Cancelled";
      break;
    case 1:
      name = "Active";
      break;
    case 2:
      name = "On-Hold";
      break;
    case 3:
      name = "Closed";
      break;
    case 4:
      name = "Lost";
      break;
  }
  return name;
};

export const getAvatarStyle = (status) => {
  switch (status) {
    case 0:
      return {
        color: "#b05500",
        backgroundColor: "#fde7d2",
      };
    case 1:
      return {
        color: "#038e00",
        backgroundColor: "#e3f1e3",
      };
    case 2:
      return {
        color: "#e4b320",
        backgroundColor: "#fdf1cb",
      };
    case 3:
      return {
        color: "#6c757d",
        backgroundColor: "#e0e1e3",
      };
    case 4:
      return {
        color: "#b00101",
        backgroundColor: "#f8cace",
      };
  }
};

export const getSourceDownArrow = (status) => {
  let name;
  switch (status) {
    case 0:
      name = require("@/assets/New-job-dashboard/cancelled-downArrow.svg");
      break;
    case 1:
      name = require("@/assets/New-job-dashboard/active-downArrow.svg");
      break;
    case 2:
      name = require("@/assets/New-job-dashboard/onHold-downArrow.svg");
      break;
    case 3:
      name = require("@/assets/New-job-dashboard/closed-downArrow.svg");
      break;
    case 4:
      name = require("@/assets/New-job-dashboard/lost-downArrow.svg");
      break;
  }
  return name;
};

export const getSourceUpArrow = (status) => {
  let name;
  switch (status) {
    case 0:
      name = require("@/assets/New-job-dashboard/cancelled-upArrow.svg");
      break;
    case 1:
      name = require("@/assets/New-job-dashboard/active-upArrow.svg");
      break;
    case 2:
      name = require("@/assets/New-job-dashboard/onHold-upArrow.svg");
      break;
    case 3:
      name = require("@/assets/New-job-dashboard/closed-upArrow.svg");
      break;
    case 4:
      name = require("@/assets/New-job-dashboard/lost-upArrow.svg");
      break;
  }
  return name;
};

export const getCurrentDate = () => {
  let today = new Date();
  let day = today.getDate();
  let month = today.getMonth() + 1; // January is 0!
  let year = today.getFullYear();

  // Add leading zero if day or month is less than 10
  if (day < 10) {
    day = "0" + day;
  }
  if (month < 10) {
    month = "0" + month;
  }

  return day + "/" + month + "/" + year;
};

export const getSelectedFormatLabels = (arr1) => {
  let arr = [...arr1];
  for (let i in arr) {
    if (arr[i] == "DOC") {
      arr[i] = "DOC and DOCX";
      let ind = arr.indexOf("DOCX");
      arr.splice(ind, 1);
    } else if (arr[i] == "PPT") {
      arr[i] = "PPT and PPTX";
      let ind = arr.indexOf("PPTX");
      arr.splice(ind, 1);
    } else if (arr[i] == "XLS") {
      arr[i] = "XLS and XLSX";
      let ind = arr.indexOf("XLSX");
      arr.splice(ind, 1);
    } else if (arr[i] == "TTF") {
      arr[i] = "TTF and TIF";
      let ind = arr.indexOf("TIF");
      arr.splice(ind, 1);
    }
  }
  return arr.join(" + ");
};

export const generateKey = (parent, label) => {
  let key = `CUSTOMFIELD_${parent}_${label.replace(
    / /g,
    "_"
  )}_${getRandomKey()}`;
  return key;
};

export const getRandomKey = () => {
  const charset =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let key = "";
  for (let i = 0; i < 8; i++) {
    const randomIndex = Math.floor(Math.random() * charset.length);
    key += charset[randomIndex];
  }
  return key;
};

export const getFileType = (fileUrl) => {
  let img;
  // Extract filename from URL
  const fileName = fileUrl
    .substring(fileUrl.lastIndexOf("/") + 1)
    .split("?")[0];
  // Get extension after last dot
  const extension = fileName.includes(".")
    ? fileName.split(".").pop().toLowerCase()
    : null;
  if (extension == "doc" || extension == "docx")
    img = require("@/assets/img/foldericons/doc-icon.svg");
  else if (extension == "zip")
    img = require("@/assets/img/foldericons/zip-icon.svg");
  else img = require("@/assets/img/foldericons/common-doc.svg");
  return [extension, img];
};

export const getFileNameFromLink = (fileUrl) => {
  let name = fileUrl
    .substring(fileUrl.lastIndexOf("/") + 1)
    .split("?")[0]
    .replace(/%20/g, " ");
  return decodeURIComponent(name);
};

export const formatYearsDate = (dateString) => {
  const date = new Date(dateString);

  // Extract day, month, and year
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  // Format the date as "dd.mm.yyyy"
  return `${year}-${month}-${day}`;
};

export const filteredFields = (normalFields, advancedFields, selectedJD) => {
  let normal = JSON.parse(JSON.stringify(normalFields));
  let advanced = JSON.parse(JSON.stringify(advancedFields));
  let docField =
    normal.find((obj) => obj.key == "documents") ||
    advanced.find((obj) => obj.key == "documents");
  if (docField) {
    let docRequired = checkValuesOfKey(docField, selectedJD);
    if (docRequired == "No") {
      if (normal.find((obj) => obj.key == "documents"))
        normal = normal.filter((obj) => obj.key != "requiredDocumets");
      else if (advanced.find((obj) => obj.key == "documents"))
        advanced = advanced.filter((obj) => obj.key != "requiredDocumets");
    }
  }
  let roleField =
    normal.find((obj) => obj.key == "role") ||
    advanced.find((obj) => obj.key == "role");
  if (roleField) {
    let roleValue = checkValuesOfKey(roleField, selectedJD);
    if (roleValue?.toLowerCase() != "others") {
      if (normal.find((obj) => obj.key == "role"))
        normal = normal.filter((obj) => obj.key != "otherRole");
      else if (advanced.find((obj) => obj.key == "role"))
        advanced = advanced.filter((obj) => obj.key != "otherRole");
    }
  }
  return [normal, advanced];
};

export const convertDateFormat = (dateStr) => {
  if (dateStr) {
    const date = new Date(dateStr);

    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }
};
